var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$style.wrapper,
    ( _obj = {}, _obj[_vm.$style.mobileSeeThroughButton] = this.isMobile, _obj ),
    ( _obj$1 = {}, _obj$1[_vm.$style.top] = this.isTop, _obj$1 ) ]},[_c('span',{class:_vm.$style.text},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-180b4443","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SeeThroughButton.vue
// module id = null
// module chunks = 